module.exports = {
  '13': {
    '0': 'device.close',
    '100': 'device.open'
  },
  '20': {
    '0': 'device.flood_normal',
    '100': 'device.flood_alarm'
  },
  '21': {
    '0': 'device.glass_normal',
    '100': 'device.glass_alarm'
  },
  '23': {
    '0': 'device.turn_off',
    '100': 'device.turn_on'
  },
  '31': {
    '0': 'device.unlock',
    '100': 'device.lock'
  },
  '32': [
    'device.fan_off',
    'device.fan_auto_low',
    'device.fan_low',
    'device.fan_auto_high',
    'device.fan_high'
  ],
  '33': [
    'device.mode_off',
    'device.mode_heat',
    'device.mode_cool',
    'device.mode_auto'
  ],
  '36': {
    '0': 'device.turn_off',
    '100': 'device.turn_on'
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/luffanet-web-components/DeviceLabels.js
// module id = wGLa
// module chunks = 0